import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, LogIn } from "lucide-react";

/**
 * Fake user menu shown in DEMO mode only — gives the impression of being
 * inside an active session. Clicking the only menu item opens /login.
 */
const FAKE = {
  name: "Camille Aebischer",
  initials: "CA",
  email: "c.aebischer@banque-cic.demo",
  organisation: "Banque CIC (Suisse) · Démo",
  role: "Risk Officer",
};

export default function DemoUserMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref} data-testid="demo-user-menu">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 pl-1.5 pr-2 py-1 rounded-md hover:bg-white/5 transition-colors"
        data-testid="demo-user-menu-btn"
      >
        <div className="w-7 h-7 rounded-md bg-[#378ADD]/20 border border-[#378ADD]/40 flex items-center justify-center text-[10px] font-semibold text-[#378ADD]">
          {FAKE.initials}
        </div>
        <div className="hidden md:block text-left leading-tight">
          <div className="text-xs text-white truncate max-w-[140px]">{FAKE.name}</div>
        </div>
        <ChevronDown className={`w-3.5 h-3.5 text-zinc-400 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 w-72 noam-card py-1.5 z-50" data-testid="demo-user-dropdown">
          <div className="px-3 py-2 border-b border-white/5">
            <div className="text-sm text-white truncate">{FAKE.name}</div>
            <div className="text-[11px] text-zinc-500 truncate">{FAKE.email}</div>
            <div className="text-[11px] text-zinc-500 truncate mt-0.5">{FAKE.organisation}</div>
            <div className="mt-1.5 inline-flex text-[10px] px-1.5 py-0.5 rounded border border-[#EF9F27]/30 bg-[#EF9F27]/10 text-[#EF9F27]">
              session démo
            </div>
          </div>
          <div className="px-3 py-2 border-b border-white/5">
            <div className="text-[11px] text-zinc-400 leading-relaxed">
              Vous explorez Noam avec des données fictives.
              Pour avoir <span className="text-white">votre propre environnement</span>,
              connectez-vous à votre espace.
            </div>
          </div>
          <Link
            to="/login"
            onClick={() => setOpen(false)}
            className="flex items-center gap-2 px-3 py-2 text-sm text-[#378ADD] hover:bg-[#378ADD]/10"
            data-testid="demo-user-login"
          >
            <LogIn className="w-3.5 h-3.5" /> Accéder à mon environnement
          </Link>
        </div>
      )}
    </div>
  );
}
